import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class StorageUtilityService {
    private sessionStorageAvailable: boolean | null = null;

    constructor() {
        this.checkSessionStorageAvailability();
    }

    private checkSessionStorageAvailability(): boolean {
        if (this.sessionStorageAvailable !== null) {
            return this.sessionStorageAvailable;
        }

        try {
            sessionStorage.setItem('_smarts_storage_check', '1');
            sessionStorage.removeItem('_smarts_storage_check');
            this.sessionStorageAvailable = true;
            return true;
        }
        catch (e) {
            this.sessionStorageAvailable = false;
            return false;
        }
    }

    getItem(key: string): string | null {
        if (!this.checkSessionStorageAvailability()) {
            return null;
        }

        try {
            return sessionStorage.getItem(key);
        }
        catch (e) {
            return null;
        }
    }

    setItem(key: string, value: string): boolean {
        if (!this.checkSessionStorageAvailability()) {
            return false;
        }

        try {
            sessionStorage.setItem(key, value);
            return true;
        }
        catch (e) {
            return false;
        }
    }

    removeItem(key: string): boolean {
        if (!this.checkSessionStorageAvailability()) {
            return false;
        }

        try {
            sessionStorage.removeItem(key);
            return true;
        }
        catch (e) {
            return false;
        }
    }

    clear(): boolean {
        if (!this.checkSessionStorageAvailability()) {
            return false;
        }

        try {
            sessionStorage.clear();
            return true;
        }
        catch (e) {
            return false;
        }
    }

}
